<template>
  <div class="activity">
    <m-loading :loading="TTtype" />
    <div class="payTopBox">
      <div class="p1">
        <div class="img">
          <img src="@/assets/images/home/daizhifu.png" />
        </div>
        <div class="txt">待支付</div>
      </div>
      <div class="p2">
        请确认您的报名信息完成支付后报名成功
        <!-- ，请在<span> 活动结束前</span>完成支付 -->
      </div>
    </div>
    <div class="payCountBox">
      <div class="item">
        <div class="p1">报名规格：</div>
        <div class="p2">{{skuData.title}}</div>
      </div>
      <div class="item">
        <div class="p1">详细信息：</div>
        <div class="p2">
          {{skuData.desc}}
        </div>
      </div>
      <div class="item">
        <div class="p1">待支付金额：</div>
        <div class="p2">
          <span class="mony">{{skuData.price}}元</span>
        </div>
      </div>
    </div>
    <div class="payBottomBox">
      <div class="btnGreen" @click="onBridgeReady()">提交</div>
      <div class="btnTxt" @click="goBack">取消支付及报名</div>
      <!-- <van-button size="large" @click="submitFnks">提交</van-button> -->
    </div>
  </div>
</template>

<script>
import SignTitle from "@/components/pub/SignTitle.vue";
import { localStorageGetItem } from "@/utils/auth";
import { getjsapisignature, gesociallogin, ordersubmit } from "@/utils/api/wx";
export default {
  components: {
    "sign-title": SignTitle
  },
  data() {
    return {
      TENANTID: "",
      role: "",
      id: "",
      skuData:{},
      TTtype:true,
      TT:'',
    };
  },
  mounted() {
    this.TENANTID = localStorageGetItem("TENANT-ID") || "0";
    let skuData =  localStorageGetItem('sku')
    skuData?skuData = JSON.parse(skuData):{}
    this.skuData =  skuData;
    this.role = this.$store.state.role;
    this.code = this.$route.query.code;
    this.state = this.$route.query.state;
    this.id = this.$route.query.id;
    if (this.code && this.id && this.state) {
      this.getsocialloginT(this.code, this.state);
    } else {
      this.goBack()
    }
  },
  methods: {
    goBack() {
      this.$router.replace({ path: '/' });
    },
    getsocialloginT(code, state) {
      let data = {
        type: 31,
        code: code,
        state: state
      };
      let left = this;
      gesociallogin(data).then((resS) => {
        if (resS.data.code == 0) {
          let T = resS.data.data;
          let datas = {
            merchantOrderId: this.id,
            appId: 7,
            channelCode: "wx_pub",
            channelExtras: {
              openid: T.openid
            }
          };
          ordersubmit(datas).then((resK) => {
            if (resK.data.code == 0) {
              let TT = resK.data.data.displayContent;
              TT = JSON.parse(TT);
              this.TT = TT;
              this.TTtype = false;
            } else if (resK.data.code == 1007003002) {
              // 订单已支付
              left.$root.$toast.success("订单已支付");
              left.getactivity()
            } else if (resK.data.code == 1007002000) {
              // 支付点单不存在
              left.$root.$toast.success("支付订单单不存在");
            } else if (resK.data.code == 1007002001) {
              // 支付订单不处于待支付状态
              left.$root.$toast.success("支付订单不处于待支付状态");
            } else if (resK.data.code == 1007002002) {
              // 订单已支付刷新页面
              left.$root.$toast.success("订单已支付");
              left.getactivity()
            } else if (resK.data.code == 1007002002) {
              // 支付订单已过期
              left.$root.$toast.success("支付订单已过期");
              left.goBack()
            } else if (resK.data.code == 1007002002) {
              left.$root.$toast.success("发起支付报错,请重新支付");
            } else if (resK.data.code == 1007002002) {
              left.$root.$toast.success("支付订单退款失败");
              left.goBack()
            }
          });
        }
      });
    },
    onBridgeReady(){
      let left = this;
      let TT = this.TT;
      if (typeof WeixinJSBridge == "undefined") {
        left.$root.$toast.success("请在微信中打开");
      } else {
        let dataTT = {
          appId: TT.appId,
          timeStamp: TT.timeStamp,
          nonceStr: TT.nonceStr,
          package: TT.packageValue,
          signType: TT.signType,
          paySign: TT.paySign
        };
        WeixinJSBridge.invoke(
          "getBrandWCPayRequest",
          dataTT,
          (res) => {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              alert('支付成功')
              // 使用以上方式判断前端返回,微信团队郑重提示：
              //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
              left.getactivity()
            } else if ( res.err_msg == "get_brand_wcpay_request:cancel" ) {
              alert('支付取消,请重新支付')
            } else if (res.err_msg == "get_brand_wcpay_request:fail") {
              alert('支付失败请重新支付')
            }
          }
        );
        // wx.chooseWXPay({
        //     appId:TT.appId,
        //     timeStamp: TT.timeStamp, // 支付签名时间戳
        //     nonceStr: TT.nonceStr, // 支付签名随机串
        //     package: TT.packageValue, // 统一支付接口返回的 prepay_id 参数值
        //     signType: TT.signType, // 签名算法，暂支持 MD5
        //     paySign:TT.paySign, // 签名
        //     success: function (res) {
        //         left.$router.replace({ path: '/' });
        //         left.$root.$toast.success(
        //           "支付成功"
        //         );
        //         console.log('支付成功');
        //     },
        //     cancel: function (res) {
        //         console.log('用户取消支付');
        //     },
        //     fail: function (res) {
        //         console.log('支付失败');
        //     }
        // });
      }
    },
    getactivity(){
      this.$router.replace({ path: '/home/activity' });
    },
    getconfig() {
      let redirect_uri = encodeURIComponent(
        window.location.origin + "/home/payment"
      );
      getjsapisignature(redirect_uri).then((res) => {
        if (res.data.code == 0) {
          let data = res.data.data;
          wx.config({
            debug: false, // 开发模式下使用
            appId: data.appId, // 必填，公众号的唯一标识
            timestamp: data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.nonceStr, // 必填，生成签名的随机串
            signature: data.signature, // 必填，签名
            jsApiList: ["chooseWXPay", "chooseWXPay"] // 必填，需要使用的JS接口列表
          });
          wx.ready(function () {
            let redirect_uri = encodeURIComponent(
              window.location.origin + "/home/payment"
            );
            let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${data.appId}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=${id}#wechat_redirect`;
            location.href = url;
          });
          wx.error(function (res) {
            this.$root.$toast.fail("支付错误请在个人中心重新支付");
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.activity {
  // padding-bottom: 100px;
  padding: 15px;
  min-height: 100vh;
  background: #f9f9fa;
  .payBottomBox {
    padding-top: 6vh;
    .btnGreen {
      background: #31d076;
      border-radius: 25px 25px 25px 25px;
      line-height: 40px;
      font-weight: bold;
      font-size: 15px;
      color: #ffffff;
    }
    .btnTxt {
      padding-top: 20px;
      font-weight: 500;
      font-size: 15px;
      color: #333333;
    }
  }
  .payCountBox {
    margin-top: 15px;
    background-color: #fff;
    padding: 15px;
    text-align: left;
    font-size: 15px;
    min-height: 50vh;
    .item {
      display: flex;
      justify-content: space-between;
      padding: 8px 0;
      .p1 {
        color: #333333;
        flex: 1;
        // display: flex;
        // align-items: center;
        min-width: 7em;
      }
      .p2 {
        color: #666666;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        span {
          color: #31d076;
        }
      }
    }
  }

  .payTopBox {
    background: linear-gradient(
      0deg,
      #ffffff 60%,
      rgba(255, 114, 70, 0.1) 100%
    );
    border-radius: 8px;
    padding: 15px;
    .p1 {
      display: flex;
      // align-items: center;
      .img {
        img {
          width: 29px;
        }
      }
      .txt {
        font-weight: bold;
        font-size: 20px;
        color: #333333;
        margin-left: 2px;
      }
    }
    .p2 {
      margin-top: 13px;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      text-align: left;
      span {
        color: #ff7246;
      }
    }
  }
}
.affairsQuery {
  position: fixed;
  width: 94px;
  height: 46px;
  right: 0;
  top: 340px;
}
</style>
<style lang="scss">
.activity {
  .van-popup {
    border-radius: 20px 20px 0 0;
    overflow-y: hidden;
    .van-icon {
      right: calc((100% - 16px) / 2);
      font-size: 16px;
      &::after {
        content: "";
        position: absolute;
        left: -3px;
        top: -3px;
        height: 20px;
        width: 20px;
        box-sizing: content-box;
        border: 1px solid #c8c9cc;
        border-radius: 50%;
      }
    }
  }
}
</style>
